import React from 'react';
import './styles.scss';
import Banner from 'components/Home/Banner';
import IntroJobstas from 'components/Home/IntroJobstas';
import PopularJobs from 'components/Home/PopularJobs';
import ForEmployees from 'components/Home/ForEmployees';
import WhatIsJobstas from 'components/Home/WhatIsJobstas';
import UsersExpect from 'components/Home/UsersExpect';
import HowItWorks from 'components/Home/HowItWorks';
import DownloadJobstasApp from 'components/Home/DownloadJobstasApp';
import useAuthStore from 'store/auth';
import { USER_TYPES } from 'constants';

const Home: React.FC = () => {
	const { token: isAuthenticated, user }: Record<string, any> = useAuthStore(
		(state) => state.userInfo ?? {},
	);
	return (
		<div className="home-page">
			<Banner />
			{!isAuthenticated && <ForEmployees />}
			<IntroJobstas />
			<WhatIsJobstas />
			<HowItWorks />
			<UsersExpect />
			{(user?.userType === USER_TYPES.SEEKER || !isAuthenticated) && <PopularJobs />}
			<DownloadJobstasApp />
		</div>
	);
};

export default Home;
